import type { BudgetNoteRowDraft, BudgetNoteUsageEntryDraft } from '../types/budgetNote';
import { normalizeBudgetNoteCategoryHeaderLabels, type BudgetNoteCategoryHeaderLabels } from './budgetNoteCategoryHeaderLabels';

export type BudgetNoteHistoryFrame = {
  rows: BudgetNoteRowDraft[];
  entries: BudgetNoteUsageEntryDraft[];
  deletedRowIds: string[];
  deletedEntryIds: string[];
  categoryHeaderLabels: BudgetNoteCategoryHeaderLabels;
};

export const BUDGET_NOTE_UNDO_HISTORY_MAX = 100;
export const BUDGET_NOTE_UNDO_COALESCE_MS = 800;

export function cloneBudgetNoteHistoryFrame(frame: BudgetNoteHistoryFrame): BudgetNoteHistoryFrame {
  return {
    rows: frame.rows.map((r) => ({ ...r })),
    entries: frame.entries.map((e) => ({ ...e })),
    deletedRowIds: [...frame.deletedRowIds],
    deletedEntryIds: [...frame.deletedEntryIds],
    categoryHeaderLabels: normalizeBudgetNoteCategoryHeaderLabels(frame.categoryHeaderLabels),
  };
}
